import { render, staticRenderFns } from "./AgreementsItem.vue?vue&type=template&id=57949025&scoped=true&"
import script from "./AgreementsItem.vue?vue&type=script&lang=js&"
export * from "./AgreementsItem.vue?vue&type=script&lang=js&"
import style0 from "./AgreementsItem.vue?vue&type=style&index=0&id=57949025&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57949025",
  null
  
)

export default component.exports